import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestRoutes } from '../_config/rest-routes.config';
import { CountExpirate } from '../_models/count-expirate.model';
import { environment } from 'src/environments/environment';
import { CommerceFileDocumentModelGet } from '../_models/commerceFilesDocumentGet.model';

@Injectable({
  providedIn: 'root'
})
export class CommerceFileDocumentService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-type': 'application/json'
      }
    )
  };

  constructor(private http: HttpClient) { }

  PostCommerceFileDocument(parameters: any): Observable<any> {
    let urlCommerces: string = `${environment.urlWS}${RestRoutes.COMMERCE_FILES_POST}`;
    return this.http.post<any>(urlCommerces, parameters, this.httpOptions);
  }

  GetCommerceFileDocument(documentType:string): Observable<CommerceFileDocumentModelGet[]> {
    let urlCommerces : string = `${environment.urlWS}${RestRoutes.COMMERCE_FILES_GET}?documentType=${documentType}`;
    return this.http.get<CommerceFileDocumentModelGet[]>(urlCommerces, this.httpOptions);
  }

  DeleteCommerceFileDocument(commerceFileId:number): Observable<any> {
    let urlCommerces : string = `${environment.urlWS}${RestRoutes.COMMERCE_FILES_GET}/${commerceFileId}`;
    return this.http.delete<any>(urlCommerces, this.httpOptions);
  }

}
